<div class="page-content container">
	<div class="page-header">
		<h1>
			<p>
				{{ translationManager.getTranslation('UsageConditions_DocumentReview') }}
			</p>
		</h1>
	</div>
	<div class="page-data shadow-sm">
		<div class="content">
			<div>
				<document-view [model]="doc"></document-view>
			</div>
			<div *ngIf="userCanVote && !userAlreadyVoted">
				<div class="form-element amb-5">
					<button type="button" class="btn btn-light" (click)="setConsentStatus(true)">
						{{ translationManager.getTranslation('Слажем се') }}
					</button>
					<button type="button" class="btn btn-light" (click)="disapprove()">
						{{ translationManager.getTranslation('Не слажем се') }}
					</button>
				</div>
			</div>
		</div>
	</div>
